import {Fragment} from 'react'
import {useTranslation} from 'react-i18next'

type Day = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'
type DayKey = `${Day}Open` | `${Day}Close`
type Opening = 'Nach Vereinbarung' | null | string
export type OpeningHours = Record<DayKey, Opening>

const days: Array<{key: Day; i18nKey: string}> = [
  {key: 'monday', i18nKey: 'common:days.monday'},
  {key: 'tuesday', i18nKey: 'common:days.tuesday'},
  {key: 'wednesday', i18nKey: 'common:days.wednesday'},
  {key: 'thursday', i18nKey: 'common:days.thursday'},
  {key: 'friday', i18nKey: 'common:days.friday'},
  {key: 'saturday', i18nKey: 'common:days.saturday'},
  {key: 'sunday', i18nKey: 'common:days.sunday'},
]

interface OpeningHoursTableProps {
  openingHours: OpeningHours
}

export const OpeningHoursTable = (props: OpeningHoursTableProps) => {
  const {openingHours} = props
  const {t} = useTranslation()

  return (
    <div className={'grid grid-cols-2 gap-x-spacing-10 gap-y-spacing-12'}>
      {days.map(({key, i18nKey}) => {
        const open = openingHours[`${key}Open`]
        const close = openingHours[`${key}Close`]

        let hours = 'Geschlossen'

        if (open === 'Nach Vereinbarung' && close === 'Nach Vereinbarung') {
          hours = 'Nach Vereinbarung'
        } else if (open && close) {
          hours = `${open} – ${close}`
        } else if (open) {
          hours = `${open} –`
        } else if (close) {
          hours = `– ${close}`
        }

        return (
          <Fragment key={key}>
            <div>{t(i18nKey)}</div>
            <div data-testid={`${key}_hours`}>{hours}</div>
          </Fragment>
        )
      })}
    </div>
  )
}
